<div class="raport-date-container">
  @if (isCustomDatePicker) {
    <div class="date-item fs-12 border-left-one border-dark-3-gray" [ngClass]="{ active: 'custom' === model }" (click)="picker.open()">
      <mat-icon class="fs-16 mt-0 pt-1">calendar_month</mat-icon>
      <span>Custom</span>
    </div>
  }
  @for (item of timePeriod; track $index) {
    @if (!isCustomDatePicker) {
      <div class="border-left-one border-dark-3-gray"></div>
    }
    <div class="date-item fs-12" (click)="onSelectTime(item)" [ngClass]="{ active: item === model }">{{ item }}</div>
  }
</div>

<div style="height: 0; width: 0; visibility: hidden">
  <mat-date-range-input [rangePicker]="picker" [formGroup]="range">
    <input matStartDate formControlName="start" placeholder="Start date" />
    <input matEndDate formControlName="end" placeholder="End date" (dateChange)="onSelectRange()" />
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</div>
